<div class="form-row sprout-composite" *ngFor="let composite of composites">
<!--  <h2>composite.key: {{composite.key}}</h2>-->
  <app-sprout-composite [hidden]="composite.display === false" [composite]="composite" [fields]="composite.fields" [form]="form"></app-sprout-composite>
  <mat-divider *ngIf="composite.display !== false" [inset]="true" class="sproutMatDivider"></mat-divider>
<!--  <app-sprout-composite *ngIf="composite.display !== false" [composite]="composite" [fields]="composite.fields" [form]="form"></app-sprout-composite>-->
<!--  <mat-divider *ngIf="composite.display !== false" [inset]="true" class="sproutMatDivider"></mat-divider>-->
</div>
